import { Products } from '@/@types';
import { ProductsListResponse } from '../products/models/ProductsListResponse';
import { mapSpecification } from './productDetailsMapper';

export function mapProducts(products: ProductsListResponse): Products {

  return {
    id: products.id,
    name: products.name,
    short_name: products.short_name,
    image: products.image,
    image_url: products.image_url,
    slug: products.slug,
    characteristics: {
      metric: products.characteristics.metric?.map(mapSpecification),
      english: products.characteristics.english?.map(mapSpecification),
      noType: products.characteristics.no_type?.map(mapSpecification),
    }
  }
}